import { styled, Toast } from '@grupoboticario/flora-react';

export const NotificationStyles = {
  Wrapper: styled('div', {
    display: 'flex',
    width: '100%',
    '&[data-position="bottom-left"]': {
      bottom: 0,
      justifyContent: 'left',
    },
    '&[data-position="bottom-right"]': {
      bottom: 0,
      justifyContent: 'right',
    },
    '&[data-position="top-center"]': {
      top: 0,
      justifyContent: 'center',
    },
    '&[data-position="top-left"]': {
      top: 0,
      justifyContent: 'left',
    },
    '&[data-position="top-right"]': {
      top: 0,
      justifyContent: 'right',
    },
  }),

  Toast: styled(Toast, {
    position: 'fixed',
    zIndex: 2000,
    '&[data-position="bottom-left"], &[data-position="bottom-right"]': {
      bottom: 0,
    },
    '&[data-position="top-center"], &[data-position="top-left"], &[data-position="top-right"]': {
      top: 0,
    },
  }),
};
